var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_181_1",
    "data-name": "Componente 181 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5771",
    "data-name": "Grupo 5771",
    transform: "translate(6 6.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170802",
    "data-name": "Grupo 170802"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_209",
    "data-name": "Elipse 209",
    cx: 26,
    cy: 26,
    rx: 26,
    ry: 26,
    transform: "translate(0 -0.264)",
    fill: "#ff7a00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170801",
    "data-name": "Grupo 170801",
    transform: "translate(-0.271 -0.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5769",
    "data-name": "Grupo 5769",
    transform: "translate(10.271 14.361)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_211",
    "data-name": "Elipse 211",
    cx: 2.582,
    cy: 3.127,
    rx: 2.582,
    ry: 3.127,
    transform: "translate(3.114 7.726)",
    fill: "#933000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_216",
    "data-name": "Trazado 216",
    d: "M894.268,595.026a18.538,18.538,0,0,1-1.788,1.423,19.944,19.944,0,0,1-1.914,1.193,12.482,12.482,0,0,1-4.331,1.477.73.73,0,0,1-.232-1.44l.022,0a10.939,10.939,0,0,0,3.679-1.521,18.18,18.18,0,0,0,1.666-1.185,16.821,16.821,0,0,0,1.5-1.346l.019-.02a.991.991,0,1,1,1.422,1.381Z",
    transform: "translate(-885.413 -593.302)",
    fill: "#933000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_217",
    "data-name": "Trazado 217",
    d: "M956.809,738.894c-4.053,0-7.4,2.662-7.939,6.117a.6.6,0,0,0,.772.667,20.322,20.322,0,0,1,14.334,0,.6.6,0,0,0,.772-.667C964.213,741.556,960.863,738.894,956.809,738.894Z",
    transform: "translate(-930.851 -706.771)",
    fill: "#933000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5770",
    "data-name": "Grupo 5770",
    transform: "translate(32.526 14.361)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_212",
    "data-name": "Elipse 212",
    cx: 2.582,
    cy: 3.127,
    rx: 2.582,
    ry: 3.127,
    transform: "translate(0.902 7.726)",
    fill: "#933000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_218",
    "data-name": "Trazado 218",
    d: "M1069.558,593.622a16.821,16.821,0,0,0,1.5,1.346,18.217,18.217,0,0,0,1.666,1.185,10.937,10.937,0,0,0,3.678,1.521l.02,0a.73.73,0,0,1-.229,1.441,12.483,12.483,0,0,1-4.331-1.477,19.965,19.965,0,0,1-1.914-1.193,18.537,18.537,0,0,1-1.788-1.423.991.991,0,0,1,1.334-1.466l.042.04Z",
    transform: "translate(-1067.837 -593.302)",
    fill: "#933000"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148765",
    "data-name": "Rect\\xE1ngulo 148765",
    width: 64,
    height: 64,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.3d59466403007ff3496837d917410a46.svg";
export { ForwardRef as ReactComponent };